import React, { useState } from "react";
import { useUser } from "../contexts/UserContext";
import LoginModal from "./LoginModal";
import UserDropdown from "./UserDropdown";

function Header() {
  const { user, isAuthenticated, login, logout } = useUser();
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);

  const handleLogin = (userData) => {
    login(userData);
  };

  const handleLoginClick = () => {
    setIsLoginModalOpen(true);
  };

  return (
    <>
      <header className="header">
        <div className="header-top">
          <div className="container">
            <div className="header-top-content">
              <div className="contact-info">
                <span>📞 707 200 200</span>
                <span>📧 info@kodly.io</span>
              </div>
              <div className="user-actions">
                {isAuthenticated ? (
                  <UserDropdown user={user} onLogout={logout} />
                ) : (
                  <button
                    className="login-link-button"
                    onClick={handleLoginClick}
                  >
                    Entrar
                  </button>
                )}
                <button className="login-link-button">Registar</button>
                <button className="login-link-button">Lojas</button>
              </div>
            </div>
          </div>
        </div>

        <div className="header-main">
          <div className="container">
            <div className="header-main-content">
              <div className="logo">
                <h1>Kodly</h1>
              </div>
              <div className="search-bar">
                <input type="text" placeholder="O que procura hoje?" />
                <button>🔍</button>
              </div>
              <div className="header-actions">
                <div className="cart">
                  🛒
                  <span className="cart-count">0</span>
                </div>
                <div className="favorites">❤️</div>
                <div className="user-account">👤</div>
              </div>
            </div>
          </div>
        </div>

        <nav className="navigation">
          <div className="container">
            <ul className="nav-menu">
              <li>
                <button className="nav-link-button">Smartphones</button>
              </li>
              <li>
                <button className="nav-link-button">Computadores</button>
              </li>
              <li>
                <button className="nav-link-button">TVs & Áudio</button>
              </li>
              <li>
                <button className="nav-link-button">Tablets</button>
              </li>
              <li>
                <button className="nav-link-button">Fotografia</button>
              </li>
              <li>
                <button className="nav-link-button">Gaming</button>
              </li>
              <li>
                <button className="nav-link-button">Casa Inteligente</button>
              </li>
              <li>
                <button className="nav-link-button">Acessórios</button>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <LoginModal
        isOpen={isLoginModalOpen}
        onClose={() => setIsLoginModalOpen(false)}
        onLogin={handleLogin}
      />
    </>
  );
}

export default Header;
